const AGENT_ROOT = '/agent/agentInformation';
export const AgentInformationRouteConstants = {
  AGENT_ROOT,
  AGENT_LICENSES: `${AGENT_ROOT}/licenses`,
  HIERARCHY: `${AGENT_ROOT}/hierarchy`,
  NY_RATE_GENERATORS: `${AGENT_ROOT}/nyrategenerators`,
  AGENT_NEWS: `${AGENT_ROOT}/news`,
};
